import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

function CoverImage({ coverImage }) {
  if (!coverImage) return null;
  const { data } = supabase.storage.from('covers').getPublicUrl(coverImage);
  return (
    <img
      src={data.publicUrl}
      alt="Cover"
      style={{ width: 300, height: 300, objectFit: 'cover', borderRadius: 'var(--radius-md)', marginBottom: 12 }}
    />
  );
}

export default function ProjectsPage() {
  const { profile } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data, error } = await supabase
          .from('projects_with_stats')
          .select('*')
          .order('created_at', { ascending: false });
        if (error) console.error('Projects load error:', error);
        setProjects(data || []);
      } catch (err) {
        console.error('Projects load exception:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div className="container mt-24 text-secondary">Loading...</div>;

  return (
    <div className="container mt-24">
      <h1 className="mb-16" style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-highlighted)', letterSpacing: '-0.3px' }}>Projects</h1>
      {projects.length === 0 ? (
        <div className="empty-state">
          <h3>No projects yet</h3>
          <p className="text-secondary">Check back soon for new tracks to listen to</p>
        </div>
      ) : (
        projects.map(p => (
          <Link key={p.id} to={`/project/${p.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="card" style={{ cursor: 'pointer' }}>
              <CoverImage coverImage={p.cover_image} />
              <div className="flex-between">
                <div>
                  <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4, color: 'var(--text-highlighted)' }}>{p.title}</h2>
                  {p.description && (
                    <p className="text-secondary text-sm">{p.description}</p>
                  )}
                </div>
                <div className="flex gap-12">
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-highlighted)' }}>{p.track_count}</div>
                    <div className="text-secondary text-sm">track{p.track_count !== 1 ? 's' : ''}</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-highlighted)' }}>{p.rating_count}</div>
                    <div className="text-secondary text-sm">rating{p.rating_count !== 1 ? 's' : ''}</div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))
      )}
    </div>
  );
}
